{
    "app.title": "Exportateur de données personnelles M365",
    "app.tagline": "Exportez vos propres données Microsoft 365 directement vers un dossier de votre ordinateur.",
    "app.privacy": "Vos données vont de Microsoft à votre disque. Rien ne transite par nos serveurs.",
    "help.heading": "Aide, FAQ et astuces",

    "nav.continue": "Continuer vers l’export →",
    "nav.back": "← Connexion et autorisations",
    "nav.signInFirst": "Connectez-vous ci-dessus pour continuer.",

    "lang.label": "Langue",
    "lang.fr": "Français",
    "lang.en": "English",

    "browser.unsupported.title": "Ce navigateur n’est pas pris en charge",
    "browser.unsupported.body": "L’exportateur nécessite Microsoft Edge ou Google Chrome. Il écrit les fichiers directement sur votre disque via une API que Firefox et Safari ne proposent pas.",
    "browser.unsupported.missing": "Fonctionnalité manquante : {feature}",
    "browser.feature.fsa": "File System Access",
    "browser.feature.idb": "IndexedDB",

    "auth.section": "Connexion",
    "auth.signIn": "Se connecter avec Microsoft",
    "auth.signOut": "Se déconnecter",
    "auth.signingIn": "Connexion en cours…",
    "auth.signedInAs": "Connecté en tant que {name}",
    "auth.notSignedIn": "Non connecté.",
    "auth.consentNote": "Seuls votre nom et votre adresse e-mail sont demandés à ce stade. Chaque module d’export demande ses propres autorisations au moment où vous le sélectionnez.",
    "auth.error": "Échec de la connexion : {message}",
    "auth.cancelled": "La connexion a été annulée.",
    "auth.notSignedInSummary": "Non connecté",
    "auth.bridge.working": "Finalisation de la connexion…",
    "auth.bridge.error": "La connexion n’a pas pu être finalisée. Vous pouvez fermer cette fenêtre et réessayer.",

    "storage.section": "Dossier de destination",
    "storage.intro": "Choisissez le dossier dans lequel l’export sera écrit. La question ne vous sera posée qu’une fois — le dossier est mémorisé d’une session à l’autre.",
    "storage.pickFolder": "Choisir un dossier…",
    "storage.chosen": "Écriture dans : {name}",
    "storage.none": "Aucun dossier choisi pour l’instant.",
    "storage.reconnect": "Reconnecter le dossier",
    "storage.reconnectNeeded": "L’autorisation d’écrire dans {name} doit être accordée à nouveau.",
    "storage.permissionDenied": "L’autorisation d’écrire dans ce dossier a été refusée.",
    "storage.cancelled": "La sélection du dossier a été annulée.",
    "storage.writeTest": "Écrire un fichier de test",
    "storage.testWritten": "{name} écrit ({bytes} octets).",
    "storage.error": "Erreur de stockage : {message}",
    "storage.written": "Écrit dans ce dossier jusqu’ici : {size}",
    "storage.showFolder": "Afficher le dossier",
    "storage.freeSpace": "Assurez-vous que le disque de destination dispose d’au moins 5 Go d’espace libre avant de lancer un export. Les navigateurs ne peuvent pas lire l’espace disque disponible : l’exportateur ne pourra donc pas vous avertir si le disque se remplit en cours d’exécution.",

    "graph.throttled": "Microsoft Graph limite le débit des requêtes. Nouvelle tentative dans {seconds} s…",

    "preflight.checking": "Vérification…",
    "preflight.reachable": "Accessible",
    "preflight.blocked": "Bloqué ({error})",
    "preflight.sizeKnown": "{items} éléments, ~{size}",
    "preflight.sizeUnknown": "{items} éléments (taille indisponible)",
    "preflight.sizeBytesOnly": "~{size}",
    "preflight.error": "Échec de la vérification : {message}",

    "modules.section": "Que souhaitez-vous exporter ?",
    "setup.intro": "Cochez tout ce que vous voulez, puis autorisez l’accès — une seule demande couvrant exactement votre sélection. La connexion est vérifiée plus tard, juste avant le démarrage de l’export.",
    "setup.confirmedSummary": "Prêt",
    "modules.unavailable": "Pas encore disponible",
    "modules.signInFirst": "Connectez-vous d’abord ci-dessus",
    "modules.noneSelected": "Aucune sélection",
    "modules.selectedCount": "{count} sélectionné(s)",
    "modules.selectAll": "Tout sélectionner",
    "modules.selectNone": "Tout désélectionner",

    "module.teams.label": "Conversations Teams",
    "module.teams.description": "Conversations individuelles, de groupe et de réunion, avec images intégrées",
    "module.teams.permission": "Lire vos messages de conversation",
    "module.mail.label": "Messagerie",
    "module.mail.description": "Votre propre boîte aux lettres, tous les dossiers",
    "module.mail.permission": "Lire vos e-mails et les paramètres de votre boîte",
    "module.onedrive.label": "OneDrive",
    "module.onedrive.description": "Vos fichiers OneDrive personnels",
    "module.onedrive.permission": "Lire vos fichiers",
    "module.calendar.label": "Calendrier",
    "module.calendar.description": "Vos calendriers et les calendriers partagés",
    "module.calendar.permission": "Lire vos calendriers",
    "module.contacts.label": "Contacts",
    "module.contacts.description": "Vos contacts (dossier Contacts principal)",
    "module.contacts.permission": "Lire vos contacts",
    "module.tasks.label": "Tâches",
    "module.tasks.description": "Vos listes Microsoft To Do",
    "module.tasks.permission": "Lire vos tâches",
    "module.onenote.label": "OneNote",
    "module.onenote.description": "Les blocs-notes auxquels vous avez accès",
    "module.onenote.permission": "Lire vos blocs-notes",

    "permissions.grant": "Autoriser l’accès",
    "permissions.requesting": "En attente de votre autorisation…",
    "permissions.needed": "Autorisation requise",
    "permissions.cancelled": "L’autorisation a été annulée. Aucun export n’est possible tant que l’accès n’est pas autorisé.",
    "permissions.error": "Échec de l’autorisation : {message}",

    "console.current": "Élément en cours",
    "console.total": "Total sur le disque",
    "console.session": "Téléchargé cette session",
    "console.progress": "Éléments",
    "console.progressValue": "{done} sur {total}",
    "console.started": "Export démarré.",
    "console.chatDone": "{label} — {messages} messages, {size}",
    "console.chatNewMessages": "{label} — {messages} nouveau(x) message(s) trouvé(s), {size}",
    "console.chatSkipped": "{label} — déjà exportée, ignorée",
    "console.paused": "En pause. La progression est enregistrée.",
    "console.stopped": "Arrêté. La progression est enregistrée.",
    "console.consentNeeded": "Autorisation requise pour continuer.",
    "console.locked": "Un autre onglet exporte déjà vers cette destination.",
    "console.restoredModule": "{module} : {items} éléments, {size}",
    "console.folderDone": "{label} — {messages} nouveau(x) message(s), {size}",
    "console.folderSkipped": "{label} — aucun nouveau message",
    "console.onedriveFolder": "Dossier créé : {path}",
    "console.onedriveCheckpoint": "{files} fichiers, {folders} dossiers jusqu’ici ({size})",
    "console.taskListDone": "{label} — {tasks} tâche(s), {size}",
    "console.taskListSkipped": "{label} — aucune tâche",
    "console.calendarDone": "{label} — {events} événement(s), {size}",
    "console.calendarSkipped": "{label} — aucun nouvel événement",
    "console.onenotePageDone": "{label} — {size}",
    "console.exportRestored": "Vue restaurée : {items} éléments, {size} déjà enregistrés.",
    "console.exportFinished": "Terminé — {size} au total.",



    "export.section": "Export",
    "export.intro": "Choisissez un dossier de destination, puis exécutez chaque module sélectionné — Démarrer vérifie d’abord l’accès, puis exécute chaque module l’un après l’autre.",
    "export.runHeading": "Exécution",
    "export.start": "Démarrer l’export",
    "export.resume": "Reprendre l’export",
    "export.pause": "Mettre en pause",
    "export.stop": "Arrêter",
    "export.grantAccess": "Autoriser l’accès pour continuer",
    "export.noFolder": "Choisissez d’abord un dossier de destination.",
    "export.noModules": "Choisissez d’abord quoi exporter.",
    "export.readySummary": "Prêt à exporter",
    "export.notReadySummary": "Pas encore prêt",
    "export.incomplete": "Cet export est inachevé. Reprenez pour continuer là où il s’est arrêté.",
    "export.paused": "En pause. Reprenez quand vous le souhaitez — rien n’est perdu.",
    "export.stopped": "Arrêté. Votre progression est enregistrée et pourra être reprise plus tard.",
    "export.permissionNeeded": "Une autorisation est nécessaire pour continuer. Choisissez Continuer et approuvez l’accès dans la fenêtre pop-up — l’export reprend automatiquement ensuite.",
    "export.checking": "Vérification…",
    "export.checkingConnection": "Confirmation de la connexion…",
    "export.checkingModule": "Vérification de l’accès ({done} sur {total}) — {module}",
    "export.checkingDone": "Vérifications d’accès terminées.",
    "export.done": "Export terminé.",
    "export.error": "Échec de l’export : {message}",
    "export.writeFailed": "Impossible d’écrire dans le dossier de destination. Cela peut signifier que le disque est plein, que l’autorisation doit être reconnectée, ou que le dossier a été déplacé ou supprimé. Vérifiez le dossier, puis choisissez Reprendre — rien n’est perdu.",
    "export.locked": "Un export est déjà en cours dans un autre onglet pour cette destination. Attendez qu’il se termine, puis choisissez Reprendre.",
    "export.withErrors": "{count} élément(s) en erreur seront réessayés à la reprise.",
    "export.moduleStarting": "Démarrage : {module}…",
    "export.moduleFinished": "{module} terminé : {items} éléments, {size}.",
    "export.moduleFailed": "{module} a échoué : {message}. Sera réessayé à la reprise.",
    "export.moduleUnavailable": "{module} n’est pas encore disponible — ignoré.",

    "scan.heading": "Vos données",
    "scan.intro": "Une carte par type. « Ouvrir » affiche ce qui est déjà exporté vers votre dossier ; « Analyser » liste le contenu de chaque type pour choisir précisément quoi exporter (ignorez cette étape pour tout exporter). Le filtre de date s’applique à Teams et Mail uniquement.",
    "scan.moduleNotSelected": "Non sélectionné pour l’export sur la page précédente.",
    "scan.run": "Analyser mon compte",
    "scan.rescan": "Relancer l’analyse",
    "scan.scanning": "Analyse en cours…",
    "scan.scanningModule": "Analyse de {module}… ({done} sur {total})",
    "scan.done": "Analyse terminée — choisissez ci-dessous quoi exporter.",
    "scan.error": "Échec de l’analyse : {message}",
    "scan.noModules": "Choisissez d’abord quoi exporter sur la page précédente.",
    "scan.notScanned": "Pas encore analysé.",
    "scan.emptyModule": "Rien trouvé pour cela.",
    "scan.selectAll": "Tout",
    "scan.selectNone": "Aucun",
    "scan.delete": "Supprimer de Microsoft",
    "scan.dateAfter": "Après",
    "scan.dateBefore": "Avant",

    "console.dateFilter": "{module} — filtre de date : de {after} à {before}.",
    "console.moduleDeselected": "{module} — rien de sélectionné, ignoré.",
    "console.folderEmptied": "Le dossier de destination est vide — nouvel export complet depuis le début.",

    "delete.prompt": "SUPPRIMER définitivement de votre compte Microsoft : {module}, {count} élément(s) sélectionné(s) et leur contenu. Action IRRÉVERSIBLE (votre export local est conservé). Tapez DELETE pour confirmer.",
    "delete.cancelled": "Suppression annulée.",
    "delete.nothingSelected": "{module} — rien à supprimer. Analysez et cochez d’abord les éléments à retirer.",
    "delete.consentFailed": "Autorisation de suppression refusée : {message}",
    "delete.started": "Suppression de {module} sur Microsoft…",
    "delete.progress": "Suppression… {count} supprimé(s)",
    "delete.teamsDone": "{deleted} de vos messages supprimés ({skipped} conservés — envoyés par d’autres ou déjà supprimés).",
    "delete.mailDone": "{deleted} messages et {folders} dossier(s) supprimés.",
    "delete.withErrors": "{count} élément(s) n’ont pas pu être supprimés.",
    "delete.done": "Suppression terminée.",
    "delete.error": "Échec de la suppression : {message}",

    "browse.open": "Ouvrir",
    "browse.notExported": "Pas encore exporté",

    "viewer.count": "{count} {unit}",
    "viewer.unit.teams": "conversations",
    "viewer.unit.mail": "messages",
    "viewer.unit.onedrive": "fichiers",
    "viewer.unit.calendar": "événements",
    "viewer.unit.contacts": "contacts",
    "viewer.unit.tasks": "tâches",
    "viewer.unit.onenote": "pages",
    "viewer.search": "Rechercher…",
    "viewer.selectPrompt": "Sélectionnez un élément à gauche pour l’afficher ici.",
    "viewer.emptyModule": "Rien n’a encore été exporté pour cela.",
    "viewer.noMatch": "Aucun résultat pour votre recherche.",
    "viewer.loading": "Chargement…",
    "viewer.itemError": "Impossible d’ouvrir cet élément. Il a peut-être été déplacé ou supprimé du dossier.",
    "viewer.download": "Télécharger {name}",

    "faq.heading": "FAQ",
    "faq.q.dataLocation": "Où vont réellement mes données ?",
    "faq.a.dataLocation": "Chaque octet voyage de Microsoft Graph, via votre navigateur, directement vers le dossier que vous choisissez sur votre propre ordinateur. Rien ne transite par nos serveurs ni n’y est stocké.",
    "faq.q.browsers": "Quels navigateurs et quels ordinateurs fonctionnent avec cet outil ?",
    "faq.a.browsers": "Microsoft Edge ou Google Chrome, sur un ordinateur de bureau ou portable — Windows, macOS, Linux et ChromeOS fonctionnent aussi bien les uns que les autres. Firefox et Safari ne proposent pas la fonctionnalité dont cet outil a besoin pour écrire directement sur votre disque.",
    "faq.q.mobile": "Puis-je l’utiliser sur mon téléphone ou ma tablette ?",
    "faq.a.mobile": "Non — un ordinateur de bureau ou portable est nécessaire. Aucun navigateur mobile ne peut écrire les fichiers directement sur l’appareil comme cet outil l’exige. Sur iPhone et iPad, cela vaut pour tous les navigateurs, y compris Chrome et Edge : Apple impose qu’ils utilisent tous le moteur de Safari, changer de navigateur n’y change donc rien.",
    "faq.q.perModuleConsent": "Pourquoi chaque module demande-t-il une autorisation séparée ?",
    "faq.a.perModuleConsent": "Seul l’accès nécessaire à ce que vous choisissez réellement d’exporter est demandé, et uniquement au moment où vous le choisissez — pas tout d’un coup au départ.",
    "faq.q.interruption": "Que se passe-t-il si je ferme l’onglet ou si mon ordinateur se met en veille en cours d’export ?",
    "faq.a.interruption": "Rien n’est perdu, hormis au maximum l’élément en cours d’écriture. Revenez, reconnectez-vous et relancez le même export — il reprend là où il s’est arrêté plutôt que de recommencer à zéro.",
    "faq.q.permissionPopup": "Pourquoi m’a-t-on demandé d’approuver l’accès en cours de route ?",
    "faq.a.permissionPopup": "C’est normal, ce n’est pas une erreur. Cela arrive la première fois qu’un module a besoin d’une autorisation que vous n’avez pas encore accordée, ou lorsqu’une session longue atteint sa limite de durée. Approuvez à nouveau l’accès et l’export reprend à partir de son dernier point de sauvegarde.",
    "faq.q.repeatExport": "Relancer l’export refait-il tout depuis le début ?",
    "faq.a.repeatExport": "Non — les éléments déjà écrits dans votre dossier sont mémorisés et ne sont ni retéléchargés ni dupliqués. Ceux qui ont changé entre-temps (message modifié, événement déplacé, contact, page ou fichier mis à jour) sont actualisés. Pour les conversations Teams, une exécution ultérieure vérifie aussi chaque conversation pour d’éventuels nouveaux messages depuis votre dernier export, et n’ajoute que ceux-ci.",

    "tips.heading": "Astuces",
    "tips.emptyFolder": "Choisissez un dossier vide pour l’export afin que tout ce qui provient de cette exécution soit facile à retrouver au même endroit.",
    "tips.keepTabOpen": "Pour un export volumineux, gardez l’onglet ouvert, ou ajoutez ce site à la liste « ne jamais mettre en veille » de votre navigateur — voir le réglage des onglets en veille dans Edge/Chrome.",
    "tips.checkSpace": "Vérifiez vous-même l’espace disque disponible avant de démarrer — le navigateur ne peut pas le faire à votre place (voir l’avertissement sous Dossier de destination).",
    "tips.samefolder": "Réutilisez le même dossier de destination d’une session à l’autre afin que les éléments déjà exportés soient reconnus plutôt que traités comme nouveaux.",
    "tips.oneModuleAtATime": "Les modules sélectionnés s’exportent l’un après l’autre, pas tous en même temps — en cas de problème, la console indique précisément quel module était en cours.",

    "error.notConfigured": "L’inscription d’application n’est pas configurée. Définissez VITE_MSAL_CLIENT_ID puis reconstruisez.",
    "error.unknown": "Une erreur inattendue s’est produite.",

    "common.retry": "Réessayer",
    "common.dismiss": "Fermer",
    "common.bytes": "{value} o",
    "common.kb": "{value} Ko",
    "common.mb": "{value} Mo",
    "common.gb": "{value} Go"
}
